/* BASIC APP CONSTANTS */
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const APP_COOKIE_NAME = "APP_COOKIE_NAME";
export const USER_COOKIE_NAME = "USER_COOKIE_NAME";
export const PASS_COOKIE_NAME = "PASS_COOKIE_NAME";
export const USER_ID_COOKIE_NAME = "USER_ID_COOKIE_NAME";
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
export const SET_SIDE_MENU_STATE = "SET_SIDE_MENU_STATE";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const SHOW_ACTION_MENU = "SHOW_ACTION_MENU";
export const HIDE_ACTION_MENU = "HIDE_ACTION_MENU";
export const SHOW_BOTTOM_TOOLBAR = "SHOW_BOTTOM_TOOLBAR";
export const HIDE_BOTTOM_TOOLBAR = "HIDE_BOTTOM_TOOLBAR";
export const SET_USER_LIST = "SET_USER_LIST";
export const EDIT_DISABLED_BUTTONS = "EDIT_DISABLED_BUTTONS";
export const SET_LOGS_LIST = "SET_LOGS_LIST";
export const THEME = "THEME";

/* <---- BASIC APP CONSTANTS ----> */

/* SOCKET CONSTANTS */
export const CONNECTED = "connected";
export const DISCONNECTED = "disconnected";
/* <---- SOCKET CONSTANTS ----> */

/* CONFIGURATION */
export const CONFIGURATION_FORM_TOOGLE_LOADING =
  "CONFIGURATION_FORM_TOOGLE_LOADING";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
/* <---- CONFIGURATION ----> */

/* USER */
export const SET_PROFILE = "SET_PROFILE";
/* <---- USER ----> */

/* USERS */
export const ADD_NEW_USER = "ADD_NEW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const OPEN_USER_FORM = "OPEN_USER_FORM";
export const CLOSE_USER_FORM = "CLOSE_USER_FORM";
export const EDIT_SELECTED_USER = "EDIT_SELECTED_USER";
export const USERS_FORM_TOOGLE_LOADING = "USERS_FORM_TOOGLE_LOADING";
/* <---- USERS ----> */

/* WORKER */
export const SET_WORKER_LIST = "SET_WORKER_LIST";
export const ADD_NEW_WORKER = "ADD_NEW_WORKER";
export const UPDATE_WORKER = "UPDATE_WORKER";
export const DELETE_WORKER = "DELETE_WORKER";
export const OPEN_WORKER_FORM = "OPEN_WORKER_FORM";
export const CLOSE_WORKER_FORM = "CLOSE_WORKER_FORM";
export const EDIT_SELECTED_WORKER = "EDIT_SELECTED_WORKER";
export const WORKER_FORM_TOOGLE_LOADING = "WORKER_FORM_TOOGLE_LOADING";
/* <---- WORKER ----> */

/* PROJECT */
export const SET_PROJECT_LIST = "SET_PROJECT_LIST";
export const ADD_NEW_PROJECT = "ADD_NEW_PROJECT";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const OPEN_PROJECT_FORM = "OPEN_PROJECT_FORM";
export const CLOSE_PROJECT_FORM = "CLOSE_PROJECT_FORM";
export const EDIT_SELECTED_PROJECT = "EDIT_SELECTED_PROJECT";
export const PROJECT_FORM_TOOGLE_LOADING = "PROJECT_FORM_TOOGLE_LOADING";
/* <---- PROJECT ----> */

/* PROJECT CONTROL */
export const SET_PROJECT_CONTROL_LIST = "SET_PROJECT_CONTROL_LIST";
export const ADD_NEW_PROJECT_CONTROL = "ADD_NEW_PROJECT_CONTROL";
export const UPDATE_PROJECT_CONTROL = "UPDATE_PROJECT_CONTROL";
export const DELETE_PROJECT_CONTROL = "DELETE_PROJECT_CONTROL";
export const OPEN_PROJECT_CONTROL_FORM = "OPEN_PROJECT_CONTROL_FORM";
export const CLOSE_PROJECT_CONTROL_FORM = "CLOSE_PROJECT_CONTROL_FORM";
export const EDIT_SELECTED_PROJECT_CONTROL = "EDIT_SELECTED_PROJECT_CONTROL";
export const PROJECT_CONTROL_FORM_TOGGLE_LOADING =
  "PROJECT_CONTROL_FORM_TOGGLE_LOADING";
/* <---- PROJECT CONTROL ----> */

/* PROJECT TASK */
export const SET_PROJECT_TASK_LIST = "SET_PROJECT_TASK_LIST";
export const ADD_NEW_PROJECT_TASK = "ADD_NEW_PROJECT_TASK";
export const UPDATE_PROJECT_TASK = "UPDATE_PROJECT_TASK";
export const DELETE_PROJECT_TASK = "DELETE_PROJECT_TASK";
export const OPEN_PROJECT_TASK_FORM = "OPEN_PROJECT_TASK_FORM";
export const CLOSE_PROJECT_TASK_FORM = "CLOSE_PROJECT_TASK_FORM";
export const EDIT_SELECTED_PROJECT_TASK = "EDIT_SELECTED_PROJECT_TASK";
export const PROJECT_TASK_FORM_TOGGLE_LOADING = "PROJECT_TASK_FORM_TOGGLE_LOADING";
/* <---- PROJECT TASK ----> */

/* TASK */
export const SET_TASK_LIST = "SET_TASK_LIST";
export const ADD_NEW_TASK = "ADD_NEW_TASK";
export const UPDATE_TASK = "UPDATE_TASK";
export const DELETE_TASK = "DELETE_TASK";
export const OPEN_TASK_FORM = "OPEN_TASK_FORM";
export const CLOSE_TASK_FORM = "CLOSE_TASK_FORM";
export const EDIT_SELECTED_TASK = "EDIT_SELECTED_TASK";
export const TASK_FORM_TOOGLE_LOADING = "TASK_FORM_TOOGLE_LOADING";
/* <---- TASK ----> */

/* ROUTES */
export const SET_ALL_ROUTES = "SET_ALL_ROUTES";
export const UPDATE_ROUTE = "UPDATE_ROUTE";
/* <---- ROUTES ----> */

/* ALERT */
export const SET_ALERT_LIST = "SET_ALERT_LIST";
export const ADD_NEW_ALERT = "ADD_NEW_ALERT";
export const UPDATE_ALERT = "UPDATE_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const OPEN_ALERT_FORM = "OPEN_ALERT_FORM";
export const CLOSE_ALERT_FORM = "CLOSE_ALERT_FORM";
export const EDIT_SELECTED_ALERT = "EDIT_SELECTED_ALERT";
export const ALERT_FORM_TOOGLE_LOADING = "ALERT_FORM_TOOGLE_LOADING";
/* <---- ALERT ----> */
